import { useAuth0 } from "@auth0/auth0-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChartColumn,
    faChevronUp,
    faGauge,
    faLayerGroup,
    faCloudSun,
    faHome,
    faDatabase,
    faEnvelope,
    faUpload,
    faDownload,
    faMoneyCheck,
    faBuilding,
    faArrowsLeftRight,
    faArrowsLeftRightToLine,
    faArrowsDownToLine,
    faArrowsUpToLine,
    faArrowsToCircle,
    faUserTimes,
    faArrowRightToFile,
    faRibbon
} from '@fortawesome/free-solid-svg-icons'
import React, {
    useContext, useEffect, useState,
} from 'react'
import {
    Accordion, AccordionContext, Badge, Button, Nav, useAccordionButton,
} from 'react-bootstrap'
import classNames from 'classnames'

import { LinkContainer } from 'react-router-bootstrap'

const SidebarNavItem = (props) => {
    const {
        icon,
        children,
        href,
        linkStyle,
    } = props

    return (
        <Nav.Item>
            <LinkContainer to={href}>
                <Nav.Link className="px-3 py-2 d-flex align-items-center" style={linkStyle}>
                    {icon ? <FontAwesomeIcon className="nav-icon ms-n3" icon={icon} />
                        : <span className="nav-icon ms-n3" />}
                    {children}
                </Nav.Link>
            </LinkContainer>
        </Nav.Item>
    );
};


const SidebarNavTitle = (props) => {
    const { children } = props

    return (
        <li className="nav-title px-3 py-2 mt-3 text-uppercase fw-bold">{children}</li>
    )
}

const SidebarNavGroupToggle = (props) => {
    const { activeEventKey } = useContext(AccordionContext)
    const { eventKey, icon, children, setIsShow, } = props

    const decoratedOnClick = useAccordionButton(eventKey)

    const isCurrentEventKey = activeEventKey === eventKey

    useEffect(() => {
        setIsShow(activeEventKey === eventKey)
    }, [activeEventKey, eventKey, setIsShow])

    return (
        <Button
            variant="link"
            type="button"
            className={classNames('rounded-0 nav-link px-3 py-2 d-flex align-items-center flex-fill w-100 shadow-none', {
                collapsed: !isCurrentEventKey,
            })}
            onClick={decoratedOnClick}
        >
            <FontAwesomeIcon className="nav-icon ms-n3" icon={icon} />
            {children}
            <div className="nav-chevron ms-auto text-end">
                <FontAwesomeIcon size="xs" icon={faChevronUp} />
            </div>
        </Button>
    )
}

const SidebarNavGroup = (props) => {
    const { toggleIcon, toggleText, children, } = props
    const [isShow, setIsShow] = useState(false)

    return (
        <Accordion as="li" bsPrefix="nav-group" className={classNames({ show: isShow })}>
            <SidebarNavGroupToggle icon={toggleIcon} eventKey="0" setIsShow={setIsShow}>{toggleText}</SidebarNavGroupToggle>
            <Accordion.Collapse eventKey="0">
                <ul className="nav-group-items list-unstyled">
                    {children}
                </ul>
            </Accordion.Collapse>
        </Accordion>
    )
}

export default function SidebarNav(props) {
    const { accountProfile, baseUrl = "" } = props;
    const { isAuthenticated, getIdTokenClaims } = useAuth0();
    const roleClaimType = 'totdata/roles';
    const viewerCanManageMembershipUi = Boolean(
        accountProfile?.isAdmin ||
        false
    );
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const checkIsAdmin = async () => {
            const claims = await getIdTokenClaims();
            const roles = claims[roleClaimType]
            const verifiedIsAdmin = roles.includes('admin');
            setIsAdmin(verifiedIsAdmin);
            console.log('Has Admin Role: ' + verifiedIsAdmin);
        };

        if (isAuthenticated) {
            checkIsAdmin();
        }

    }, []);

    return (
        <ul className="list-unstyled">
            <SidebarNavItem icon={faHome} href="/" linkStyle={{ paddingTop: '4px' }}>
                Home
            </SidebarNavItem>

            <SidebarNavItem icon={faRibbon} href="/membership-plans">
                Membership Plans
                <small className="ms-auto"><Badge bg="info" className="ms-auto">NEW</Badge></small>
            </SidebarNavItem>

            {(() => {
                if (accountProfile.accountType === "Admin" || accountProfile.accountType === "Sender" || accountProfile.accountType === "SenderReceiver") {
                    return <>
                        <SidebarNavTitle>Operated</SidebarNavTitle>
                        <SidebarNavItem icon={faUpload} href="/import">Import</SidebarNavItem>
                        <SidebarNavItem icon={faDatabase} href="/datafiles">Data Files</SidebarNavItem>
                        {<SidebarNavItem icon={faBuilding} href="/mappedowners">My Owners</SidebarNavItem>}
                    </>
                } else if (accountProfile.hasDocConversion) {
                    return null
                }
                else {
                    return null
                }
            })()}

            {(() => {
                if (accountProfile.accountType === "Admin" || accountProfile.accountType === "Sender" || (accountProfile.accountType === "Receiver" && !accountProfile.hasDocConversion) || accountProfile.accountType === "SenderReceiver") {
                    return <>
                        <SidebarNavTitle>Non-Operated</SidebarNavTitle>
                        <SidebarNavItem icon={faMoneyCheck} href="/checkfiles">Statements</SidebarNavItem>
                        <SidebarNavItem icon={faArrowRightToFile} href={"/documentconversion"}>Document Conversion</SidebarNavItem>
                        <SidebarNavItem icon={faBuilding} href="/sendingoperators">My Operators</SidebarNavItem>
                    </>
                } else if (accountProfile.hasDocConversion) {
                    return <>
                        <SidebarNavTitle>Non-Operated</SidebarNavTitle>
                        <SidebarNavItem icon={faArrowRightToFile} href={"/documentconversion"}>Document Conversion</SidebarNavItem>
                    </>
                }
                else {
                    return null
                }
            })()}

            {(() => {
                if (isAdmin) {
                    return <>
                        <SidebarNavTitle>Admin</SidebarNavTitle>
                        <SidebarNavItem icon={faUserTimes} href="/unregister">Unregister User</SidebarNavItem>
                    </>
                }
                else {
                    return null
                }
            })()}
        </ul>
    )
} 